import React, { useState, useEffect } from 'react';
import MD from './MD';
import { HANDBUCH, searchHandbuch } from '../help/handbuch';

/**
 * Hilfe & Benutzerhandbuch:
 * - Suche über alle Abschnitte (Titel + Suchbegriffe + Volltext) mit Direktsprung
 * - Inhaltsverzeichnis links, gewählter Abschnitt rechts (mobil gestapelt)
 * - initialSection erlaubt kontextuelle ?-Buttons („öffne Hilfe genau hier")
 */
export default function HelpModal({ initialSection, onClose }) {
  const [active, setActive] = useState(initialSection || 'ueberblick');
  const [q, setQ] = useState('');

  useEffect(() => { setActive(initialSection || 'ueberblick'); }, [initialSection]);
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const hits = searchHandbuch(q);
  const section = HANDBUCH.find(s => s.id === active) || HANDBUCH[0];
  const jump = (id) => { setActive(id); setQ(''); };

  return (
    <div className="modal-backdrop" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal help-modal">
        <div className="modal-header">
          <span className="modal-title">❓ Hilfe &amp; Benutzerhandbuch</span>
          <div className="modal-header-actions">
            <button className="btn-outline" onClick={onClose} title="Hilfe schließen (Esc)">✕ Schließen</button>
          </div>
        </div>
        <div className="modal-body help-body">

          <input
            className="field-input help-search"
            type="search"
            placeholder={'Funktion suchen … z.B. „kombinieren", „Video", „Faktencheck", „läuft bereits"'}
            value={q}
            onChange={e => setQ(e.target.value)}
            autoFocus
            aria-label="Im Handbuch suchen"
          />

          {q.trim().length >= 2 ? (
            <div className="help-results">
              {hits.length === 0 && (
                <p className="help-noresult">Nichts gefunden für „{q}" — probier ein anderes Wort (z.B. den Button-Text).</p>
              )}
              {hits.map(h => (
                <button key={h.id} className="help-result" onClick={() => jump(h.id)}
                  title={`Zum Abschnitt „${h.title}" springen`}>
                  <span className="help-result-title">{h.icon} {h.title}</span>
                  {h.snippet && <span className="help-result-snippet">{h.snippet}</span>}
                </button>
              ))}
            </div>
          ) : (
            <div className="help-layout">
              <nav className="help-toc" aria-label="Handbuch-Inhalt">
                {HANDBUCH.map(s => (
                  <button key={s.id}
                    className={`help-toc-item ${s.id === active ? 'help-toc-on' : ''}`}
                    onClick={() => setActive(s.id)}
                    title={s.title}>
                    {s.icon} {s.title}
                  </button>
                ))}
              </nav>
              <article className="help-content">
                <h2 className="help-content-title">{section.icon} {section.title}</h2>
                <MD content={section.body} />
              </article>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
